export default __webpack_public_path__ + "static/media/Filler-Harmony-8-1-22.deb19c0d.gif";